export const workspaceConstants = {
  GET_WORKSPACE_DETAILS_REQUEST: "GET_WORKSPACE_DETAILS_REQUEST",
  GET_WORKSPACE_DETAILS_SUCCESS: "GET_WORKSPACE_DETAILS_SUCCESS",
  GET_WORKSPACE_DETAILS_FAILURE: "GET_WORKSPACE_DETAILS_FAILURE",

  CREATE_WORKSPACE_DETAILS_REQUEST: "CREATE_WORKSPACE_DETAILS_REQUEST",
  CREATE_WORKSPACE_DETAILS_SUCCESS: "CREATE_WORKSPACE_DETAILS_SUCCESS",
  CREATE_WORKSPACE_DETAILS_FAILURE: "CREATE_WORKSPACE_DETAILS_FAILURE",

  UPDATE_WORKSPACE_DETAILS_REQUEST: "UPDATE_WORKSPACE_DETAILS_REQUEST",
  UPDATE_WORKSPACE_DETAILS_SUCCESS: "UPDATE_WORKSPACE_DETAILS_SUCCESS",
  UPDATE_WORKSPACE_DETAILS_FAILURE: "UPDATE_WORKSPACE_DETAILS_FAILURE",

  GET_ALL_ACTIVE_WORKSPACE_REQUEST: "GET_ALL_ACTIVE_WORKSPACE_REQUEST",
  GET_ALL_ACTIVE_WORKSPACE_SUCCESS: "GET_ALL_ACTIVE_WORKSPACE_SUCCESS",
  GET_ALL_ACTIVE_WORKSPACE_FAILURE: "GET_ALL_ACTIVE_WORKSPACE_FAILURE",

  DELETE_WORKSPACE_DETAILS_REQUEST: "DELETE_WORKSPACE_DETAILS_REQUEST",
  DELETE_WORKSPACE_DETAILS_SUCCESS: "DELETE_WORKSPACE_DETAILS_SUCCESS",
  DELETE_WORKSPACE_DETAILS_FAILURE: "DELETE_WORKSPACE_DETAILS_FAILURE",

  GET_WORKSPACE_PROPS_REQUEST: "GET_WORKSPACE_PROPS_REQUEST",
  GET_WORKSPACE_PROPS_SUCCESS: "GET_WORKSPACE_PROPS_SUCCESS",
  GET_WORKSPACE_PROPS_FAILURE: "GET_WORKSPACE_PROPS_FAILURE",
};
